import Api from './rest/CrmLeadApi';

export default new Api();
